/**
 * YI needs to make sure that published date is specified correctly.
 * Default behavior of AA is to set published date to today's date
 * To overcome this we created this synthetic variable, that we can use as a marker of non-existent date
 */
export const YI_PUBLISHED_DATE_HAS_NOT_SPECIFIED = '2222-02-22T22:22:22.222Z'

export const YOGA_INTERNATIONAL_CONTENT_POLICY_NAME = 'Yoga International Default Policy'

export const BRIGHTCOVE_YOGA_INTERNATIONAL_PROVIDER = 'BRIGHTCOVE_YOGA_INTERNATIONAL'

export const timeZone = 'America/Denver'
